var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcDashboard(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_10515",
    "data-name": "Group 10515",
    transform: "translate(-350 -244)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_104",
    "data-name": "Rectangle 104",
    width: 30,
    height: 30,
    transform: "translate(350 244)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "dashboard",
    d: "M25.047,11.939A12.576,12.576,0,0,0,0,13.577a12.448,12.448,0,0,0,3.939,9.13,5.072,5.072,0,0,0,3.515,1.35H17.69a5.234,5.234,0,0,0,3.677-1.5,12.517,12.517,0,0,0,3.68-10.62ZM19.9,21.056a3.144,3.144,0,0,1-2.212.9H7.454a3,3,0,0,1-2.076-.777A10.375,10.375,0,0,1,2.1,13.577a10.5,10.5,0,0,1,3.5-7.815A10.355,10.355,0,0,1,12.561,3.1a11.059,11.059,0,0,1,1.23.069,10.474,10.474,0,0,1,6.111,17.9ZM8.182,18.067a1.049,1.049,0,0,1-1.467,1.5A8.385,8.385,0,0,1,13.774,5.278a1.048,1.048,0,0,1,.888,1.187,1.036,1.036,0,0,1-1.187.889A6.288,6.288,0,0,0,8.182,18.067Zm12.693-5.689a8.46,8.46,0,0,1,.085,1.2,8.312,8.312,0,0,1-2.524,5.99,1.049,1.049,0,0,1-1.467-1.5A6.267,6.267,0,0,0,18.8,12.679a1.049,1.049,0,1,1,2.076-.3Zm-6.281.661a2.131,2.131,0,1,1-1.482-1.482L17.075,7.6a1.048,1.048,0,1,1,1.482,1.482Z",
    transform: "translate(352.422 246.48)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcDashboard);
export default __webpack_public_path__ + "static/media/ic_dashboard.da9c727058ec6a96d85ca634a4662c94.svg";
export { ForwardRef as ReactComponent };